import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../shared/shared.module';
import { rolesRoutes } from './roles.routes';

import { RoleListComponent } from './role-list/role-list.component';
import { CreateRoleComponent } from './create-role/create-role.component';
import { PermissionSelectorComponent } from './components/permission-selector/permission-selector.component';
import { RoleDetailComponent } from './role-detail/role-detail.component';
import { RoleEditComponent } from './role-edit/role-edit.component';
import { EditModeBannerComponent } from './components/edit-mode-banner/edit-mode-banner.component';
import { RoleSidebarComponent } from './components/role-sidebar/role-sidebar.component';
import { HasPermissionDirective } from '../../core/authentication/directives/has-permission.directive';

@NgModule({
  declarations: [
    RoleListComponent,
    CreateRoleComponent,
    PermissionSelectorComponent,
    RoleDetailComponent,
    RoleEditComponent,
    RoleSidebarComponent,
    EditModeBannerComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    RouterModule.forChild(rolesRoutes),
    HasPermissionDirective
  ]
})
export class RolesModule { }
